<template>
    <div class="container customer-container pt-6">
        <customer-heading ref="heading" :customer="customer" :show-profile-link="onProfilePage"/>
        <div class="row">
            <div class="col-auto inline-block hide-on-small" style="width:200px">
                <customer-sidebar />
            </div>
            <div class="col-md col-sm-12 p-0">
                <router-view ref="page" :customer="customer" @mounted="pageMounted" />
            </div>
        </div>
    </div>
</template>
<script>
import CustomerHeading from "./partials/CustomerHeading";
import CustomerSidebar from "./partials/CustomerSidebar";
import { route, get } from "@utils/network";

import '@styles/customer.css';

export default {
    name: "CustomerPage",
    components: {
        CustomerHeading, CustomerSidebar
    },

    computed: {
        authenticatedUser() {
            return this.$store.getters.authenticatedUser;
        },
        onProfilePage() {
            return this.$router.currentRoute.name != "My Profile";
        },
    },

    data: () => ({
        customer: {},
    }),

    methods: {
        initializeUser() {
            if (this.$route.query.id) {
                return this.fetchUserData(this.$route.query.id);
            }
            this.customer = this.authenticatedUser;
            this.emmitUserInitialization();
        },

        fetchUserData(id) {
            get(route("users/:id", { id }))
                .then(response => {
                    this.customer = response.data.result.user;
                    this.emmitUserInitialization();
                })
                .catch(error => {
                    console.log(error);
                    this.promptErrors("Please reload the page");
                })
        },

        emmitUserInitialization() {
            if (this.$refs.page && this.$refs.page.initializeUser) {
                this.$refs.page.initializeUser(this.customer);
            }
        },
        
        pageMounted() {
            this.emmitUserInitialization();
        },
    },

    watch: {
        authenticatedUser(newValue, oldValue) {
            if ((oldValue === null || oldValue === undefined || oldValue.id == null) && newValue.id != null) {
                this.initializeUser();
            }
        },
    },

    mounted() {
        this.initializeUser();
    }
};
</script>